"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _smile = _interopRequireDefault(require("cccisd-icons/smile"));
var _wondering = _interopRequireDefault(require("cccisd-icons/wondering"));
var _notification = _interopRequireDefault(require("cccisd-icons/notification"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var OverallPercent = function OverallPercent(props) {
  var overallFidelity = props.data.overallFidelity;
  var targetFidelity = props.settings.targetScore ? props.settings.targetScore : props.data.targetFidelity;
  var _renderTargetInfo = function _renderTargetInfo() {
    if (!overallFidelity || !targetFidelity) {
      return /*#__PURE__*/_react["default"].createElement("div", null, "No data found");
    }
    var icon = /*#__PURE__*/_react["default"].createElement(_smile["default"], {
      spaceRight: true
    });
    var color = '#3673b6';
    var targetText;
    if (overallFidelity > targetFidelity) {
      targetText = 'Above Target';
    } else if (overallFidelity === targetFidelity) {
      targetText = 'At Target';
    } else {
      icon = /*#__PURE__*/_react["default"].createElement(_wondering["default"], {
        spaceRight: true
      });
      color = '#d03916';
      targetText = 'Below Target';
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].bigScore,
      style: {
        color: color
      }
    }, icon, " ", overallFidelity), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].targetIndicator,
      style: {
        color: color
      }
    }, /*#__PURE__*/_react["default"].createElement(_notification["default"], null), " ", targetText));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, _renderTargetInfo());
};
var _default = exports["default"] = OverallPercent;